import React from 'react';

const NavigationContext = React.createContext(null);

export default NavigationContext;
